import axios from 'axios'
import { Url, grafana_Url } from "../config/env"

//基础数据获取
// const URL = 'http://127.0.0.1:5005/'
const request_data = axios.create({
    baseURL: Url + 'data',
    grafana_Url: grafana_Url,
    timeout: 5000,
})
//添加请求拦截器
request_data.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
})
//添加响应拦截器
request_data.interceptors.request.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
})

export default request_data
export {
    request_data
}